<script setup>
import { computed } from 'vue'
import store from "../../../store";

const notifications = computed(() => {
    return store.getters["notifications/getNotifications"];
});
</script>

<template>
    <div class="popup-stack">
        <div :key="notification.id" v-for="notification in notifications">
            <Transition name="fade">
                <div :class="['popup', notification.type]">
                    {{ notification.message }}
                </div>
            </Transition>
        </div>
    </div>
</template>


<style scoped>
.popup-stack {
    position: fixed;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1000;
}

.popup {
    position: relative;
    padding: 10px 20px;
    border-radius: 5px;
    color: white;
    font-size: 16px;
}

.popup.info {
    background: blue;
}

.popup.success {
    background: green;
}

.popup.error {
    background: red;
}

.popup.warning {
    background: orange;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
</style>
